import { ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInput } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { CustomRoleClient } from '@frontend/role/api';
import { CustomRole, CustomRoleQueryParams } from '@frontend/role/types';
import React, { useState } from 'react';

const ID = 'custom-role-select';
export interface CustomRoleSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    submitted?: boolean;
    onChange?: (newValue: string | null) => void;
    onChangeObject?: (newValue: CustomRole | null) => void;
    value?: string | null;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<CustomRoleQueryParams>;
}

export const CustomRoleSelect = (props: CustomRoleSelectProps) => {
    const [v, cV] = useState<CustomRole | null>(null);
    return (
        <ObjectSelectInput<CustomRole, DefaultQueryParams>
            id={`${ID}${props.id && '-' + props.id}`}
            label={CommonMessage.OBJECTS.CUSTOM_ROLE.DEFAULT}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(props) => CustomRoleClient.fetchCustomRoles(props)}
            itemLabel={(account) => account.name}
        />
    );
};
